export default __webpack_public_path__ + "static/media/thumb_down.df2f5919.svg";